/* tslint:disable */

import { Action } from '@ngrx/store';
export const LOAD_SCHOOL = '[Portal] Load School';
export const LOAD_SCHOOL_FAIL = '[Portal] Load School Fail';
export const LOAD_SCHOOL_SUCCESS = '[Portal] Load School Success';

export class LoadSchool implements Action {
  readonly type = LOAD_SCHOOL;
  constructor(public payload: any) {}
}

export class LoadSchoolFail implements Action {
  readonly type = LOAD_SCHOOL_FAIL;
  constructor(public payload: any) {}
}

export class LoadSchoolSuccess implements Action {
  readonly type = LOAD_SCHOOL_SUCCESS;
  constructor(public payload: object) {}
}

// action types
export type SchoolAction = LoadSchool | LoadSchoolFail | LoadSchoolSuccess;
